export default __webpack_public_path__ + "static/media/crypto deposit.ffdefe86.png";